import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Input, Button, Typography, notification, Radio, Row, Col, Select, } from "antd";
import { MailOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { authService, countryService, } from "../services";
import { COMPANY_LOGO, ROLE } from "../constants";
import { type } from "@testing-library/user-event/dist/type";
import { IoPersonOutline } from "react-icons/io5";
import { Tabs } from "antd";
import { FiPhone, FiPlus } from "react-icons/fi";
import { RiGalleryLine } from "react-icons/ri";
import { LuFlag } from "react-icons/lu";

const { Title } = Typography;

const { TabPane } = Tabs;

const SignForm = () => {
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [active, setActive] = useState("Truck");

  const navigate = useNavigate();
  const options = {
    Truck: "Truck as dispatcher",
    Customer: "customer",
  }

  const onFinish = async (values) => {
    setLoading(true);
    const data = {
      name: values.username,
      email: values.email,
      password: values.password,
      country: values.country,
      phone: values.phone,
      type: active === "Truck" ? "Truck as dispatcher" : "customer",
    };

    const authResponse = await authService.signUpPost(data);
    setLoading(false)
    if (authResponse.success) {
      notification.success({
        message: "Signup Successful!",
        description: "You have successfully signed up.",
      });
      navigate("/login");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Form Submission Failed:", errorInfo);
  };

  const fetchCountries = async () => {
    const response = await countryService.countryGet();
    if (response?.success) {
      setCountries(response.data);
    } else {
      console.error("Failed to fetch countries:", response.message);
    }
  };

  // const fetchDrivers = async () => {
  //   const response = await driverService.driverGet();
  //   if (response.success) {
  //     const mappedOptions = response.data.map((item) => ({
  //       label: item.name,       // What user sees
  //       value: item.name,       // What gets selected
  //     }));
  //     setOptions(mappedOptions);
  //     setSelectedValue(mappedOptions[0]?.value || "");
  //   } else {
  //     console.error("Failed to fetch drivers:", response.message);
  //   }
  // };
  const handleSelect = (label) => {
    setActive(label);
  };

  useEffect(() => {
    fetchCountries();
    const mappedOptions = ROLE.map((role) => ({
      label: role,
      value: role,
    }));
  }, []);

  return (
    <div >
      <Form
        className="signup-form"
        layout="vertical"
        style={{ width: "380px" }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="flex w-full justify-between  mt-8 mb-4 ">
          <div className="w-1/2">
            <Title style={{ fontSize: "20px" }}>Register</Title>
            <p>Start For Free</p>
          </div>

          <div className="flex w-full justify-end items-center">
            <div className="flex w-[70%] bg-[#F0F0F0] rounded-full overflow-hidden">
              <Button
                type={active === "Truck" ? "primary" : "text"}
                onClick={() => handleSelect("Truck")}
                className={`flex-1 py-5 font-medium transition-all duration-300 ${active === "Truck" ? "rounded-full" : "text-black"
                  }`}
              >
                Truck
              </Button>
              <Button
                type={active === "Customer" ? "primary" : "text"}
                onClick={() => handleSelect("Customer")}
                className={`flex-1 py-5 font-medium transition-all duration-300 ${active === "Customer" ? "rounded-full" : "text-black"
                  }`}
              >
                Customer
              </Button>
            </div>
          </div>

        </div>


        <Form.Item
          label="Full Name"
          name="username"
          rules={[{ required: true, message: "Please input your Username!" }]}

        >
          <Input
            prefix={<UserOutlined style={{ paddingRight: "10px", paddingLeft: "2px" }} />}
            style={{ borderRadius: "12px", height: "40px" }}
            placeholder="Enter your Username"
            allowClear
          />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { type: "email", message: "The input is not a valid email!" },
            { required: true, message: "Please input your email!" },
          ]}
        >
          <Input
            prefix={<MailOutlined style={{ paddingRight: "10px", paddingLeft: "2px" }} />}
            style={{ borderRadius: "12px", height: "40px" }}
            placeholder="Enter your email"
            allowClear
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined style={{ paddingRight: "10px", paddingLeft: "2px" }} />}
            style={{ borderRadius: "12px", height: "40px" }}
            placeholder="Enter your password"
            allowClear
            autoComplete="new-password"
          />
        </Form.Item>
        <Row gutter={14}>
          <Col span={8}>
            <Form.Item
              label="Country Code"
              name="country"
              rules={[{ required: true, message: "Please select a country!" }]}
            >
              <Select showSearch optionFilterProp="label" variant="borderless" className="borderSelect" placeholder="code" prefix={<LuFlag style={{ paddingRight: "10px", paddingLeft: "2px", fontSize: 26 }} />}>
                <Select.Option value="" disabled selected style={{ color: "#B0B0B0" }}>
                  Select Code
                </Select.Option>
                {countries.map((country) => {
                  let iso = country.iso_code.split('/')[0].trim()
                  return (
                    <Select.Option key={country.id} value={country.iso_code} label={country.country_code} // <-- used for search filtering
                    >
                      <div className="flex items-center">
                        <img
                          style={{ width: 20, height: 14, marginRight: 8 }}
                          src={`https://flagcdn.com/24x18/${iso.toLowerCase()}.png`}
                        />
                        {country.country_code}
                      </div>
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="Phone No"
              name="phone"
              rules={[
                { required: true, message: "Please input your phone number!" },
              ]}
            >
              <Input
                prefix={<FiPhone style={{ paddingRight: "4px", paddingLeft: "2px", fontSize: 22 }} />}
                type="number"
                placeholder="Phone No"
                style={{ borderRadius: "12px", height: "40px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item >
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ width: "100%", borderRadius: "12px", height: "40px", marginTop: "15px" }}
          >
            Register
          </Button>
        </Form.Item>
        <div>
          <p style={{ textAlign: "center" }}>
            Already a member?{" "}
            <Link to="/login" className="font-bold hover:underline hover:text-primary">
              Login
            </Link>
          </p>
        </div>
      </Form>


    </div >
  );
};

export default SignForm;



// {selectedValue === option.value ? (
//                       option.value.includes("Trucker") ? (
//                         // <img
//                         //   src="/images/tr2.png"
//                         //   alt="Trucker"
//                         //   style={{ width: "12px", height: "12px", marginRight: "6px" }}
//                         // />
//                         <p></p>
//                       ) : (
//                         <p></p>
//                         // <IoPersonOutline style={{ width: "12px", height: "12px", marginRight: "6px" }} />
//                       )
//                     ) : option.value.includes("Trucker") ? (
//                       <p></p>
//                       // <img
//                       //   src="/images/tr.png"
//                       //   alt="Trucker"
//                       //   style={{ width: "12px", height: "12px", marginRight: "6px" }}
//                       // />
//                     ) : (
//                       <p></p>
//                       // <IoPersonOutline style={{ width: "12px", height: "12px", marginRight: "6px" }} />
//                     )}